import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    mobile: '',
    slectedValue: '0',
    selectedHot: "2",
    selectedOrder: "buy",
  },
  mutations: {
    changeUsername(state, value) {
      state.mobile = value
    },
    changeSelectedValue(state, value) {
      localStorage.setItem("slectedValue", value)
      state.slectedValue = value
    },
    changeSelectedHot(state, value) {
      localStorage.setItem("selectedHot", value)
      state.selectedHot = value
    },
    changeSelectedOrder(state, value) {
      localStorage.setItem("selectedOrder", value)
      state.selectedOrder = value
    }
  },
  actions: {
    change(context, value) {
      // commit提交

      context.commit('changeUsername', value)
    }
  },
  modules: {
  }
})
